import { render, staticRenderFns } from "./WsChips001.vue?vue&type=template&id=a5d40fa8"
import script from "./WsChips001.vue?vue&type=script&lang=js"
export * from "./WsChips001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports